import { ActivityFilterKey } from '@gripp/shared-logic';
import { ActivityList, Colors, tokens, typography } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';

type AccountActivityPanelProps = {
  accountId: string;
  workspaceId: string;
};

/**
 * The People page's per-person activity column (plan 0030, Phase 4): the
 * third column opened by AccountDetailPanel's "View Activity" action. Reuses
 * ActivityList with its own ActivityFilterKey.AccountActivity storage key
 * (see 4.3) — never the main or asset-feed keys — so opening this panel
 * cannot disturb either of those filters.
 *
 * `workspaceId` is passed through explicitly rather than left to
 * ActivityList's own useCurrentWorkspace fallback: on the global-admin
 * /accounts/:workspaceId route, the active workspace and the
 * workspace this panel is scoped to are not the same thing.
 */
export const AccountActivityPanel = ({
  accountId,
  workspaceId,
}: AccountActivityPanelProps) => {
  const { t } = useTranslation();

  return (
    <View style={styles.container} testID="account-activity-panel">
      {/* The two Activity numbers differ by definition (plan 0030): the
          People-page column counts live grants only, this panel also
          includes activity the person created or posted in — not a bug,
          so it's labelled by what it actually shows rather than implying
          the two match. */}
      <Text style={styles.description}>
        {t('account.detail.activityPanel.description')}
      </Text>
      <ActivityList
        filterKey={ActivityFilterKey.AccountActivity}
        accountId={accountId}
        workspaceId={workspaceId}
        showAssetName
        showTopBar={false}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  description: {
    ...typography.body.small,
    color: Colors.role.textSecondary,
    paddingHorizontal: tokens.spacing.lg,
    paddingTop: tokens.spacing.md,
    paddingBottom: tokens.spacing.sm,
  },
});
